export default "__VITE_ASSET__dB6GTIG6__"